import React from 'react';
import { NavBar, Footer } from '../components';
import { EventHero, EventOverview, EventGallery, EventReflections } from '../components/Event';

const GuestSpeakerEvent = () => {

  return (
    <div className="min-h-screen bg-white">
      <NavBar />
      <EventHero />
      <EventOverview />
      <EventGallery />
      <EventReflections />
      <Footer />
    </div>
  );
};

export default GuestSpeakerEvent;